import { Button } from "@shared/ui/button";
import { BriefcaseBusiness, ArrowLeft, Play, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@shared/components/PageHeader";
import { useState } from "react";
import { ManageBanksModal } from "../components/ManageBanksModal";
import DayEndReconciliationList from "../list/list";
import { StartReconciliationModal } from "../components/StartReconciliationModal";

const DayEndReconcilationLanding = () => {
  const navigate = useNavigate();
  const [isManageBanksOpen, setIsManageBanksOpen] = useState(false);
  const [isStartReconciliationOpen, setIsStartReconciliationOpen] = useState(false);

  return (
    <div className="flex h-full flex-col gap-4 p-2">
      <div className="flex justify-between items-start mb-6">
        <div className="flex items-center gap-4">
          <ArrowLeft
            className="w-5 h-5 cursor-pointer text-gray-700"
            onClick={() => navigate("/cx/payments")}
          />
          <div className="flex flex-col">
            <PageHeader
              title={"Day-End Reconcilation"}
              subtitle="Match system payments to bank deposits across every channel — cash, ACH, wire, check, card, Zelle, kiosk, lockbox. Sign off the day to lock the ledger and archive the audit-ready report."
            />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" onClick={() => setIsManageBanksOpen(true)}>
            <BriefcaseBusiness className="h-4 w-4 mr-2" />
            Manage Banks
          </Button>
          <Button variant="outline" onClick={() => setIsStartReconciliationOpen(true)}>
            <Play className="h-4 w-4 mr-2" />
            Start Reconciliation
          </Button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <DayEndReconciliationList />
      </div>

      <ManageBanksModal
        isOpen={isManageBanksOpen}
        onClose={() => setIsManageBanksOpen(false)}
      />

      <StartReconciliationModal
        isOpen={isStartReconciliationOpen}
        onClose={() => setIsStartReconciliationOpen(false)}
      />
    </div>
  );
};

export default DayEndReconcilationLanding;
